export enum CardColor {
    HEART = 0,
    DIAMOND = 1,
    SPADE = 2,
    CLUB = 3,
}



// WEBPACK FOOTER //
// ./src/app/api/CardColor.ts